import React from 'react';
import CostcoLocationTemplate from '../../components/CostcoLocationTemplate';

const MoorabbinPage = () => (
  <CostcoLocationTemplate
    warehouseName="Moorabbin Airport"
    suburb="Moorabbin"
    state="Victoria"
    stateShort="VIC"
    address="Moorabbin Airport, Centre Rd, Moorabbin VIC 3189"
    path="/costco/moorabbin"
    description="Manage Your Loans is the proud Costco member loan partner for the Moorabbin Airport warehouse in Melbourne's bayside region. We help Costco Executive Members across Moorabbin, Mentone, Cheltenham, Hampton and surrounding suburbs access competitive home loans, car loans and personal loans — with exclusive Costco Shop Card rewards on settlement."
    nearbySuburbs={[
      'Moorabbin',
      'Mentone',
      'Cheltenham',
      'Hampton',
      'Highett',
      'Bentleigh',
      'Bentleigh East',
      'Parkdale',
      'Brighton East',
      'Heatherton',
    ]}
    localContext={[
      {
        title: 'Bayside Melbourne Property Market',
        description:
          'The bayside region is one of Melbourne\'s most desirable property markets, with proximity to beaches, excellent schools and established village-style shopping strips. Suburbs like Hampton, Mentone and Brighton East command premium prices and attract discerning buyers.',
      },
      {
        title: 'Established Suburbs with Strong Demand',
        description:
          'Suburbs such as Bentleigh, Cheltenham and Highett have seen sustained demand from both owner-occupiers and investors. Heritage homes, period conversions and modern townhouses create a diverse market where tailored lending solutions make a real difference.',
      },
      {
        title: 'Premium Market and Refinancing Opportunities',
        description:
          'Higher property values in the bayside corridor mean refinancing and equity access are common goals for homeowners. Whether you are looking to renovate, invest or consolidate, competitive loan structuring is essential in this premium market segment.',
      },
    ]}
    faqs={[
      {
        q: 'How do I claim my Costco Shop Card reward after settling a loan?',
        a:
          'Once your loan settles through Manage Your Loans, we verify your Costco Executive Membership and arrange your Shop Card reward. The process is straightforward — just ensure your membership is active at the time of settlement. Terms and conditions apply.',
      },
      {
        q: 'Can I access the Costco member loan service if I live in Mentone or Hampton?',
        a:
          'Yes. Our Costco member loan partnership serves all suburbs near the Moorabbin Airport warehouse, including Mentone, Hampton, Cheltenham, Highett, Bentleigh, Bentleigh East, Parkdale, Brighton East, Heatherton and surrounding areas.',
      },
      {
        q: 'What types of loans qualify for the Costco Shop Card offer?',
        a:
          'Home loans, car loans, and personal loans settled through Manage Your Loans as a Costco Executive Member may qualify for Shop Card rewards. Each loan type has specific terms — contact us on 0468 007 056 for details.',
      },
      {
        q: 'Do you assist with refinancing for bayside properties?',
        a:
          'Absolutely. Many of our bayside clients refinance to access equity, secure a better rate or fund renovations. As your Costco member loan partner, we compare options across our lender panel to find the right fit — and you may also qualify for a Costco Shop Card reward on settlement.',
      },
    ]}
    suburbData={{
      suburb: 'Moorabbin',
      medianHouse: '$1,180,000',
      medianUnit: '$620,000',
      daysOnMarket: '24 days',
      rentalYield: '2.9%',
      population: '7,200',
      distanceToCostco: '2 km',
    }}
    surroundingSuburbs={[
      { suburb: 'Mentone', medianHouse: '$1,250,000', medianUnit: '$650,000', daysOnMarket: '22 days' },
      { suburb: 'Cheltenham', medianHouse: '$1,150,000', medianUnit: '$600,000', daysOnMarket: '24 days' },
      { suburb: 'Hampton', medianHouse: '$1,650,000', medianUnit: '$720,000', daysOnMarket: '20 days' },
      { suburb: 'Highett', medianHouse: '$1,300,000', medianUnit: '$640,000', daysOnMarket: '23 days' },
      { suburb: 'Bentleigh', medianHouse: '$1,400,000', medianUnit: '$670,000', daysOnMarket: '22 days' },
      { suburb: 'Bentleigh East', medianHouse: '$1,280,000', medianUnit: '$630,000', daysOnMarket: '25 days' },
      { suburb: 'Parkdale', medianHouse: '$1,200,000', medianUnit: '$610,000', daysOnMarket: '24 days' },
      { suburb: 'Brighton East', medianHouse: '$1,800,000', medianUnit: '$750,000', daysOnMarket: '19 days' },
      { suburb: 'Heatherton', medianHouse: '$1,100,000', medianUnit: '$580,000', daysOnMarket: '28 days' },
    ]}
  />
);

export default MoorabbinPage;
